/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Reservations_TitleInputs */

const en_inventory_reservations_title = /** @type {(inputs: Inventory_Reservations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory Reservations`)
};

const es_inventory_reservations_title = /** @type {(inputs: Inventory_Reservations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas de inventario`)
};

/**
* | output |
* | --- |
* | "Inventory Reservations" |
*
* @param {Inventory_Reservations_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_reservations_title = /** @type {((inputs?: Inventory_Reservations_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Reservations_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_reservations_title(inputs)
	return es_inventory_reservations_title(inputs)
});